import { render, staticRenderFns } from "./CommonContextMenu.vue?vue&type=template&id=72307ca4"
import script from "./CommonContextMenu.vue?vue&type=script&lang=js"
export * from "./CommonContextMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports